// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WorkflowsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WorkflowsIcon" ref={forwardedRef} {...props}>
      <path d="M11.25 6a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5z" />
      <path d="M8.75 7.683a.5.5 0 0 0 0-.866l-2.25-1.3a.5.5 0 0 0-.75.434v2.598A.5.5 0 0 0 6.5 8.982z" />
      <path d="M6 12.933a.5.5 0 0 1 0-.866l2.25-1.3A.5.5 0 0 1 9 11.202V13.8a.5.5 0 0 1-.75.433z" />
      <path d="M12.75 14.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5" />
      <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v13A1.5 1.5 0 0 0 3.5 18h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 16.5 2zm13 1.5v13h-13v-13z" />
    </SvgIcon>
  );
});

/**
 * @deprecated Change of functional and app icon usage guidelines. Use app icon instead
 * @public
 */
export const WorkflowsIcon = /* @__PURE__ */ Object.assign(
  WorkflowsIconComponent,
  { displayName: 'WorkflowsIcon' },
);
